import { getRegisterFunction } from '../../utils/register.js';
import { OneUxProgressElement } from './OneUxProgressElement.js';
export const register = getRegisterFunction(OneUxProgressElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-progress': OneUxProgressElement;
    "progress-43fd01c70771ee5ba106aba168d0abab": OneUxProgressElement;
  }
}